import {
    GET_DATADOG_ALL_RESOURCE_COUNT,
    GET_DATADOG_ALL_RESOURCE_COUNT_SUCCESS,
    GET_DATADOG_ALL_RESOURCE_COUNT_FAIL,
    GET_ALL_ORG_DATADOG_RESOURCE_TYPES,
    GET_ALL_ORG_DATADOG_RESOURCE_TYPES_SUCCESS,
    GET_ALL_ORG_DATADOG_RESOURCE_TYPES_FAIL,
    GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE,
    GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    POST_DATADOG_SERVICE_MAPPING,
    POST_DATADOG_SERVICE_MAPPING_SUCCESS,
    POST_DATADOG_SERVICE_MAPPING_FAIL,
    POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING,
    POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING_SUCCESS,
    POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING_FAIL,
    GET_DATADOG_REFRESH,
    GET_DATADOG_REFRESH_SUCCESS,
    GET_DATADOG_REFRESH_FAIL,
    GET_DATADOG_DEFAULT_THRESHOLD,
    GET_DATADOG_DEFAULT_THRESHOLD_SUCCESS,
    GET_DATADOG_DEFAULT_THRESHOLD_FAIL,
    GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD,
    GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
    GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
    GET_DATADOG_RESOURCES,
    GET_DATADOG_RESOURCES_SUCCESS,
    GET_DATADOG_RESOURCES_FAIL,
    PUT_DATADOG_THRESHOLD,
    PUT_DATADOG_THRESHOLD_SUCCESS,
    PUT_DATADOG_THRESHOLD_FAIL,
    POST_DATADOG_DISABLE_THRESHOLD_ALERTS,
    POST_DATADOG_DISABLE_THRESHOLD_ALERTS_SUCCESS,
    POST_DATADOG_DISABLE_THRESHOLD_ALERTS_FAIL,
    POST_DATADOG_ENABLE_THRESHOLD_ALERTS,
    POST_DATADOG_ENABLE_THRESHOLD_ALERTS_SUCCESS,
    POST_DATADOG_ENABLE_THRESHOLD_ALERTS_FAIL,
    GET_DATADOG_ALERTS,
    GET_DATADOG_ALERTS_SUCCESS,
    GET_DATADOG_ALERTS_FAIL,
    GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_DATADOG_RESOURCE_BY_ID,
    GET_DATADOG_RESOURCE_BY_ID_SUCCESS,
    GET_DATADOG_RESOURCE_BY_ID_FAIL,
    GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID,
    GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID_SUCCESS,
    GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID_FAIL,
    GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
    GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
    GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
    GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
    POST_DATADOG_CREATE_RESOURCE_ALERTS,
    POST_DATADOG_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_DATADOG_CREATE_RESOURCE_ALERTS_FAIL,
    PUT_DATADOG_ALERTS,
    PUT_DATADOG_ALERTS_SUCCESS,
    PUT_DATADOG_ALERTS_FAIL,
    POST_DATADOG_ENABLE_ALERTS,
    POST_DATADOG_ENABLE_ALERTS_SUCCESS,
    POST_DATADOG_ENABLE_ALERTS_FAIL,
    POST_DATADOG_DISABLE_ALERTS,
    POST_DATADOG_DISABLE_ALERTS_SUCCESS,
    POST_DATADOG_DISABLE_ALERTS_FAIL,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_FAIL,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_SUCCESS,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_FAIL,
    GET_DATADOG_API_ENDPOINTS_BY_APM,
    GET_DATADOG_API_ENDPOINTS_BY_APM_SUCCESS,
    GET_DATADOG_API_ENDPOINTS_BY_APM_FAIL,
    POST_DATADOG_REGISTER_ENDPOINT,
    POST_DATADOG_REGISTER_ENDPOINT_SUCCESS,
    POST_DATADOG_REGISTER_ENDPOINT_FAIL,
    GET_USER_RESCAN_STATUS_DATADOG,
    GET_USER_RESCAN_STATUS_DATADOG_FAIL,
    GET_USER_RESCAN_STATUS_DATADOG_SUCCESS
} from "./actionTypes"


export const getDatadogAllResourceCount = (page_filters) => ({
    type: GET_DATADOG_ALL_RESOURCE_COUNT,
    payload: { page_filters }
})

export const getDatadogAllResourceCountSuccess = (response) => ({
    type: GET_DATADOG_ALL_RESOURCE_COUNT_SUCCESS,
    payload: response
})

export const getDatadogAllResourceCountFail = (error) => ({
    type: GET_DATADOG_ALL_RESOURCE_COUNT_FAIL,
    payload: error
})

export const getDatadogAllServiceDependencyResourceCount = (page_filters) => ({
    type: GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT,
    payload: { page_filters}
})

export const getDatadogAllServiceDependencyResourceCountSuccess = (response) => ({
    type: GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_SUCCESS,
    payload: response
})

export const getDatadogAllServiceDependencyResourceCountFail = (error) => ({
    type: GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_FAIL,
    payload: error
})

export const getAllOrgDatadogResourceTypes = () => ({
    type: GET_ALL_ORG_DATADOG_RESOURCE_TYPES
})

export const getAllOrgDatadogResourceTypesSuccess = (response) => ({
    type: GET_ALL_ORG_DATADOG_RESOURCE_TYPES_SUCCESS,
    payload: response
})

export const getAllOrgDatadogResourceTypesFail = (error) => ({
    type: GET_ALL_ORG_DATADOG_RESOURCE_TYPES_FAIL,
    payload: error
})

export const getDatadogAllResourceAlertsPage = (page_filters) => ({
    type: GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE,
    payload: { page_filters }
})

export const getDatadogAllResourceAlertsPageSuccess = (response) => ({
    type: GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: response
})

export const getDatadogAllResourceAlertsPageFail = (error) => ({
    type: GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error
})

export const postDatadogServiceMapping = (service_mapping) => ({
    type: POST_DATADOG_SERVICE_MAPPING,
    payload: { service_mapping }
})

export const postDatadogServiceMappingSuccess = (response) => ({
    type: POST_DATADOG_SERVICE_MAPPING_SUCCESS,
    payload: response
})

export const postDatadogServiceMappingFail = (error) => ({
    type: POST_DATADOG_SERVICE_MAPPING_FAIL,
    payload: error
})

export const postDatadogResourceOpsgenieTeamMapping = (datadog_resource_team_mapping) => ({
    type: POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: { datadog_resource_team_mapping }
})


export const postDatadogResourceOpsgenieTeamMappingSuccess = (response) => ({
    type: POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    payload: response
})

export const postDatadogResourceOpsgenieTeamMappingFail = (error) => ({
    type: POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    payload: error
})

export const postDatadogResourcePagerdutyServiceMapping = (datadog_resource_pagerduty_service_mapping) => ({
    type: POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING,
    payload: { datadog_resource_pagerduty_service_mapping }
})

export const postDatadogResourcePagerdutyServiceMappingSuccess = (response) => ({
    type: POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING_SUCCESS,
    payload: response
})

export const postDatadogResourcePagerdutyServiceMappingFail = (error) => ({
    type: POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING_FAIL,
    payload: error
})

export const getDatadogRefresh = () => ({
    type: GET_DATADOG_REFRESH
})

export const getDatadogRefreshSuccess = (response) => ({
    type: GET_DATADOG_REFRESH_SUCCESS,
    payload: response
})

export const getDatadogRefreshFail = (error) => ({
    type: GET_DATADOG_REFRESH_FAIL,
    payload: error
})

export const getDatadogDefaultThreshold = (data) => ({
    type: GET_DATADOG_DEFAULT_THRESHOLD,
    payload: data
})

export const getDatadogDefaultThresholdSuccess = (response) => ({
    type: GET_DATADOG_DEFAULT_THRESHOLD_SUCCESS,
    payload: response
})

export const getDatadogDefaultThresholdFail = (error) => ({
    type: GET_DATADOG_DEFAULT_THRESHOLD_FAIL,
    payload: error
})

export const getDatadogDynamicDefaultThreshold = (data) => ({
    type: GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD,
    payload: data
})

export const getDatadogDynamicDefaultThresholdSuccess = (response) => ({
    type: GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
    payload: response
})

export const getDatadogDynamicDefaultThresholdFail = (error) => ({
    type: GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
    payload: error
})

export const getDatadogAllServicesDependencyResourceAlerts =  (page_filters) => ({
    type: GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE,
    payload: { page_filters }
})

export const getDatadogAllServicesDependencyResourceAlertsSuccess = (response) => ({
    type: GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: response
})

export const getDatadogAllServicesDependencyResourceAlertsFail = (error) => ({
    type: GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error
})

export const getDatadogResources = () => ({
    type: GET_DATADOG_RESOURCES
})

export const getDatadogResourcesSuccess = (response) => ({
    type: GET_DATADOG_RESOURCES_SUCCESS,
    payload: response
})

export const getDatadogResourcesFail = (error) => ({
    type: GET_DATADOG_RESOURCES_FAIL,
    payload: error
})

export const putDatadogThreshold = (thresholds) => ({
    type: PUT_DATADOG_THRESHOLD,
    payload: {thresholds}
})

export const putDatadogThresholdSuccess = (response) => ({
    type: PUT_DATADOG_THRESHOLD_SUCCESS,
    payload: response
})

export const putDatadogThresholdFail = (error) => ({
    type: PUT_DATADOG_THRESHOLD_FAIL,
    payload: error
})

export const postDatadogDisableThresholdAlerts = (alerts) => ({
    type: POST_DATADOG_DISABLE_THRESHOLD_ALERTS,
    payload: {alerts}
})

export const postDatadogDisableThresholdAlertsSuccess = (response) => ({
    type: POST_DATADOG_DISABLE_THRESHOLD_ALERTS_SUCCESS,
    payload: response
})

export const postDatadogDisableThresholdAlertsFail = (error) => ({
    type: POST_DATADOG_DISABLE_THRESHOLD_ALERTS_FAIL,
    payload: error
})

export const postDatadogEnableThresholdAlerts = (alerts) => ({
    type: POST_DATADOG_ENABLE_THRESHOLD_ALERTS,
    payload: {alerts}
})

export const postDatadogEnableThresholdAlertsSuccess = (response) => ({
    type: POST_DATADOG_ENABLE_THRESHOLD_ALERTS_SUCCESS,
    payload: response
})

export const postDatadogEnableThresholdAlertsFail = (error) => ({
    type: POST_DATADOG_ENABLE_THRESHOLD_ALERTS_FAIL,
    payload: error
})

export const getDatadogAlerts = (data) => ({
    type: GET_DATADOG_ALERTS,
    payload: data
})

export const getDatadogAlertsSuccess = (response) => ({
    type: GET_DATADOG_ALERTS_SUCCESS,
    payload: response
})

export const getDatadogAlertsFail = (error) => ({
    type: GET_DATADOG_ALERTS_FAIL,
    payload: error
})

export const getDatadogMissingAlertsByResourceId = (data) => ({
    type: GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getDatadogMissingAlertsByResourceIdSuccess = (response) => ({
    type: GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: response
})

export const getDatadogMissingAlertsByResourceIdFail = (error) => ({
    type: GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getDatadogResourceById = (data) => ({
    type: GET_DATADOG_RESOURCE_BY_ID,
    payload: data
})

export const getDatadogResourceByIdSuccess = (response) => ({
    type: GET_DATADOG_RESOURCE_BY_ID_SUCCESS,
    payload: response
})

export const getDatadogResourceByIdFail = (error) => ({
    type: GET_DATADOG_RESOURCE_BY_ID_FAIL,
    payload: error
})

export const getDefaultThresholdsDatadogResourceById = (data) => ({
    type: GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID,
    payload: data
})

export const getDefaultThresholdsDatadogResourceByIdSuccess = (response) => ({
    type: GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID_SUCCESS,
    payload: response
})

export const getDefaultThresholdsDatadogResourceByIdFail = (error) => ({
    type: GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID_FAIL,
    payload: error
})

export const getDatadogDynamicAlertsDeployedByResourceId = (data) => ({
    type: GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
    payload: data
})

export const getDatadogDynamicAlertsDeployedByResourceIdSuccess = (response) => ({
    type: GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
    payload: response
})

export const getDatadogDynamicAlertsDeployedByResourceIdFail = (error) => ({
    type: GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getDatadogMissingDynamicAlertsByResourceId = (data) => ({
    type: GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getDatadogMissingDynamicAlertsByResourceIdSuccess = (response) => ({
    type: GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: response
})

export const getDatadogMissingDynamicAlertsByResourceIdFail = (error) => ({
    type: GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const postDatadogCreateResourceAlerts = (alerts) => ({
    type: POST_DATADOG_CREATE_RESOURCE_ALERTS,
    payload: {alerts}
})

export const postDatadogCreateResourceAlertsSuccess = (response) => ({
    type: POST_DATADOG_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: response
})

export const postDatadogCreateResourceAlertsFail = (error) => ({
    type: POST_DATADOG_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error
})

export const putDatadogAlerts = (alerts) => ({
    type: PUT_DATADOG_ALERTS,
    payload: {alerts}
})

export const putDatadogAlertsSuccess = (response) => ({
    type: PUT_DATADOG_ALERTS_SUCCESS,
    payload: response
})

export const putDatadogAlertsFail = (error) => ({
    type: PUT_DATADOG_ALERTS_FAIL,
    payload: error
})

export const postDatadogEnableAlerts = (alerts) => ({
    type: POST_DATADOG_ENABLE_ALERTS,
    payload: {alerts}
})

export const postDatadogEnableAlertsSuccess = (response) => ({
    type: POST_DATADOG_ENABLE_ALERTS_SUCCESS,
    payload: response
})

export const postDatadogEnableAlertsFail = (error) => ({
    type: POST_DATADOG_ENABLE_ALERTS_FAIL,
    payload: error
})

export const postDatadogDisableAlerts = (alerts) => ({
    type: POST_DATADOG_DISABLE_ALERTS,
    payload: {alerts}
})

export const postDatadogDisableAlertsSuccess = (response) => ({
    type: POST_DATADOG_DISABLE_ALERTS_SUCCESS,
    payload: response
})

export const postDatadogDisableAlertsFail = (error) => ({
    type: POST_DATADOG_DISABLE_ALERTS_FAIL,
    payload: error
})

export const getDatadogApiEndpointsByApm = (page_filters) => ({
    type: GET_DATADOG_API_ENDPOINTS_BY_APM,
    payload:{page_filters}
});

export const getDatadogApiEndpointsByApmSuccess = (response) => ({
    type: GET_DATADOG_API_ENDPOINTS_BY_APM_SUCCESS,
    payload: response
});

export const getDatadogApiEndpointsByApmFail = (error) => ({
    type: GET_DATADOG_API_ENDPOINTS_BY_APM_FAIL,
    payload: error
});

export const postDatadogRegisterEndpoint = (payload) => ({
    type: POST_DATADOG_REGISTER_ENDPOINT,
    payload: payload
});

export const postDatadogRegisterEndpointSuccess = (response) => ({
    type: POST_DATADOG_REGISTER_ENDPOINT_SUCCESS,
    payload: response
});

export const postDatadogRegisterEndpointFail = (error) => ({
    type: POST_DATADOG_REGISTER_ENDPOINT_FAIL,
    payload: error
});

export const getDataDogRefreshScanStatus = () => ({
    type: GET_USER_RESCAN_STATUS_DATADOG,
})

export const getDataDogRefreshScanStatusSuccess = datadog_refresh_status => ({
    type: GET_USER_RESCAN_STATUS_DATADOG_SUCCESS,
    payload: datadog_refresh_status,
})

export const getDataDogRefreshScanStatusFail = error => ({
    type: GET_USER_RESCAN_STATUS_DATADOG_FAIL,
    payload: error,
})
